const COMMON_PPREFIX = "store/messagesReducer";

export const SET_PROCESSING = `${COMMON_PPREFIX}/SET_PROCESSING`;
export const FETCH_MESSAGES = `${COMMON_PPREFIX}/FETCH_MESSAGES`;
